<router-outlet></router-outlet>

<div [style.direction]="'ltr'">
  @if (toastService.showToast()) {
    <mars-alert-inline
      class="toast"
      [alertData]="toastService.toasterData().alertData"
      [hasCloseIcon]="toastService.toasterData().hasCloseIcon"
      [hasIcon]="toastService.toasterData().hasIcon"
      (onAlertClose)="
        toastService.showToast.set(false); toastService.resetInterval()
      " />
  }

  <mars-modal [modal]="modalService.modalContent()" />
</div>
